export default "__VITE_ASSET__CC_gS1eb__"